// extracted by mini-css-extract-plugin
export var btn = "veil-module--btn--k1p7K";
export var full = "veil-module--full--JbWv9";
export var root = "veil-module--root--XdvE3";